import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React, { useRef, useEffect, useState } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { TextL, TextM } from '../../../../infra/dls/components/typography/typography';
import InfoEngageV2 from '../icons/info-engage-v2.svg';
import { withAliases } from '../../../../infra/ui/utils/with-aliases';
var Actions = function (_a) {
    var children = _a.children, className = _a.className;
    return (_jsx("div", { className: classNames(styles['row-actions'], className), children: children }));
};
var AccordionContent = function (_a) {
    var children = _a.children, className = _a.className;
    return (_jsx("div", { className: classNames(styles.inner, className), children: children }));
};
var BaseCollapsibleRow = function (_a) {
    var _b, _c;
    var id = _a.id, title = _a.title, _d = _a.open, open = _d === void 0 ? false : _d, children = _a.children, subtitle = _a.subtitle, Icon = _a.Icon, _e = _a.displayTooltip, displayTooltip = _e === void 0 ? false : _e, onTooltipClick = _a.onTooltipClick, onClick = _a.onClick, className = _a.className, automationId = _a.automationId;
    var contentRef = useRef(null);
    var innerRef = useRef(null);
    // prevents animation on initial render
    var _f = useState(false), hasInteracted = _f[0], setHasInteracted = _f[1];
    useEffect(function () {
        var _a;
        if (innerRef.current) {
            var height = innerRef.current.offsetHeight;
            (_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.style.setProperty('--content-height', "".concat(height, "px"));
        }
    }, [children]);
    var actionsElement = React.Children.toArray(children).find(function (child) { return React.isValidElement(child) && child.type === Actions; });
    var accordionContentElement = React.Children.toArray(children).find(function (child) { return React.isValidElement(child) && child.type === AccordionContent; });
    var handleClick = function () {
        if (!hasInteracted && onClick) {
            setHasInteracted(true);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    useEffect(function () {
        if (open && !onClick) {
            setHasInteracted(true);
        }
    }, [open, onClick]);
    return (_jsxs("div", { className: classNames(styles['collapsible-row'], (_b = {}, _b[styles['is-pointer']] = !!onClick, _b), className), onClick: handleClick, "data-automation-id": "container:".concat(automationId), children: [_jsxs("div", { className: classNames(styles.header), children: [_jsxs("div", { className: styles['header-content'], children: [Icon && _jsx("div", { className: styles['title-icon'], children: Icon }), _jsxs("div", { className: styles['title-container'], children: [_jsxs(TextL, { color: "primary", className: classNames(styles.title, 'text-strong'), automationId: "text:".concat(automationId, ":title"), children: [title, displayTooltip && (_jsx(InfoEngageV2, { onClick: onTooltipClick, "data-testid": "".concat(id !== null && id !== void 0 ? id : title, "-tooltip"), className: styles['tooltip-icon'] }))] }), subtitle && (_jsx(TextM, { color: "secondary", automationId: "text:".concat(automationId, ":subTitle"), children: subtitle }))] })] }), actionsElement] }), _jsx("div", { ref: contentRef, className: classNames(styles.content, (_c = {},
                    _c[styles['is-open']] = open,
                    _c[styles['has-interacted']] = hasInteracted,
                    _c)), children: _jsx("div", { ref: innerRef, className: classNames(styles['content-element']), children: accordionContentElement }) })] }));
};
export var CollapsibleRow = withAliases(BaseCollapsibleRow, {
    Actions: Actions,
    AccordionContent: AccordionContent,
});
